import { render, staticRenderFns } from "./project-document-revisions.html?vue&type=template&id=07452fc9&"
import script from "./ProjectDocumentRevisions.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentRevisions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocumentRevisions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports